module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/axios/index.js
// module id = 18
// module chunks = 1